// extracted by mini-css-extract-plugin
module.exports = {"container":"CardImageHeader_container__GGpa7","noPadding":"CardImageHeader_noPadding__rYKT1"};